import React from "react";
import Moment from "moment";
import { createCSVDownload } from "../../../helpers/utils";
import { FileDownload as FileDownloadIcon } from "@mui/icons-material";

export function AiTopicsCSV(props) {
  const { listData } = props;

  const exportToCsv = () => {
    let filename = "6ix-Ai-topics.csv";
    let csvData = [];
    let csvHead = ["Name", "Conversation", "Created On", "Last Updated"];
    csvData.push(csvHead);
    for (let i = 0; i < listData.length; i++) {
      let item = listData?.[i];
      let row = [
        item?.name,
        item?.conversation,
        item?.createdAt
          ? Moment(item?.createdAt).format("MMM DD, YYYY : hh:mm A")
          : "",
        item?.updatedAt
          ? Moment(item?.updatedAt).format("MMM DD, YYYY : hh:mm A")
          : "",
      ];
      csvData.push(row);
    }
    createCSVDownload(filename, csvData);
  };
  return (
    <>
      {listData?.length > 0 ? (
        <button
          type="button"
          onClick={() => {
            exportToCsv();
          }}
          className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
        >
          <FileDownloadIcon className="m-r-5" /> Export CSV
        </button>
      ) : null}
    </>
  );
}
